import axios from "axios";
import { message } from "antd";

const url = process.env.REACT_APP_API_KEY;
// const url = 'https://osool-be-i6rfpew5qq-uc.a.run.app/api/';

export const EnableNotifications = (params, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}EnableNotifications?IsEnable=${params}`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const ChangeLanguageReq = (params, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}ChangeLanguage?IsArabic=${params}`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const ChangePasswordReq = (params, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}ChangePassword${params}`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const EditMyProfile = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Employee/EditMyProfile`,
    data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const AddOrUpdateFinancingAgency = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingAgencies/AddOrUpdateFinancingAgency`,
    data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const deleteAgency = (AgencyId, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}FinancingAgencies/DeleteFinancingAgency?FinancingAgencyId=${AgencyId}`,
    // data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAllFinancingAgencies = (onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingAgencies/GetAllFinancingAgencies`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const GetFinancingAgencyEmployeesByAgencyId = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingAgencyEmployee/GetFinancingAgencyEmployeesByAgencyId?FinancingAgencyId=${id}`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAccountingRatioByAgencyId = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}AccountingRatio/GetAccountingRatioByAgencyId?FinancingAgencyId=${id}`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const UploadFinancingRequestFile = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/UploadOrderFile`,
    data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const AddTransferOwnershipRequest = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}TransferOwnerships/AddTransferOwnershipRequest`,
    data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const EditCustomer = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Customer/EditCustomer`,
    data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};
